import { Link, useNavigate } from "react-router-dom";
import Layout from "../include/layout";
import { myroutes } from "../../routes/webroute";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import $ from "jquery"
import TypespublicationsService from "../../services/TypespublicationsService";
import { useSelector } from "react-redux";

export default function CreateTypesPublications() {

    //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const navigate = useNavigate()
    const [validationError, setValidationError] = useState({})
    const token = useSelector(state => state.auth.token)

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [libelle, setLibelle] = useState('')
    const [description, setDescription] = useState('')

    ///Save form data
    const handleSubmit = async (event) => {
        event.preventDefault()
        let form = {
            libelle, description
        }

        await TypespublicationsService.store(form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                    showConfirmButton: false,
                    timer: 2000
                })
                setValidationError(response.data.erreur)
            } else {
                //redirection sur index
                navigate(myroutes.typespublications_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    useEffect(() => {
        $("#submenu-2").addClass("show")
    }, [])

    //##########################/// END METHODES ##########################///

    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Gestion</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.typespublications_index} >Types publications</Link></li>
                                        <li className="breadcrumb-item active">Nouveau type de publication</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Enregistrement </h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-3">
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>
                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }} onSubmit={handleSubmit}>
                           
                                <Row>
                                    <Col md={12} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Libelle <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setLibelle(e.target.value)}
                                                value={libelle}
                                                placeholder="Libelle"
                                                name="libelle"
                                                aria-label="libelle"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                               
                                <Row>
                                    <Col md={12} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Description  <i className="text-danger"></i>
                                            </Form.Label>
                                            <textarea value={description} name="resume" id="" cols="30" onChange={(e) => setDescription(e.target.value)} rows="5" className="form-control summernote border border-info border rounded-2" placeholder=""></textarea>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Button type="submit" variant="primary">Enregistrer</Button>
                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}